<ng-template [ngIf]="isBocciandoConsegna">
  <app-loading></app-loading>
</ng-template>
<div class="d-flex mt-1 ">
  <form [formGroup]="bocciaConsegnaForm">
    <div class="grid formgrid p-fluid ">
      <div class="field col-6">
        <label for="dataInvio" >Data invio ad INFRATEL</label>
        <p-calendar
            formControlName="dataInvio"
            id="dataInvio"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            placeholder="Data invio"
            [appendTo]="'body'"
          ></p-calendar>
      </div>
      <div class="field col-6">
        <label for="dataRicevimento" >Data ricevimento risposta</label>
        <p-calendar
          formControlName="dataRicevimento"
          id="dataRicevimento"
          [showIcon]="true"
          dateFormat="dd/mm/yy"
          placeholder="Data ricevimento"
          [appendTo]="'body'"
        ></p-calendar>
      </div>
      <div  class="field col-12">
        <label for="note" >Note bocciatura</label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="note" rows="5" formControlName="note" [autoResize]="true"  pInputTextarea ></textarea>
        </span>
      </div>
  </div>
</form>
</div>
  <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isBocciandoConsegna || !bocciaConsegnaForm.valid"></p-button>
</div>
<!-- <p-toast />
<p-confirmDialog />  -->